export default __webpack_public_path__ + "static/media/gl-8.2c901a63.png";